<template>
	<div>
		<portal v-if="showWide" to="smartpanel-wide">
			<component
				:is="tool.componentName"
				v-for="(tool, index) in panels.wide.tools"
				v-show="panels.wide.expandedIndex === null || panels.wide.expandedIndex === index"
				:key="index"
				panel="wide"
				:scenario="scenario"
				:entity="tool.entity"
				:expanded="panels.wide.expandedIndex === index"
				@remove="removeTool('wide', index)"
				@expand="expandTool('wide', index)"
				v-on="$listeners"
			/>
		</portal>
		<portal v-if="showSlim" to="smartpanel-slim">
			<component
				:is="tool.componentName"
				v-for="(tool, index) in panels.slim.tools"
				v-show="panels.slim.expandedIndex === null || panels.slim.expandedIndex === index"
				:key="index"
				panel="slim"
				:scenario="scenario"
				:entity="tool.entity"
				:expanded="panels.slim.expandedIndex === index"
				:display-name="tool.displayName"
				:searchable="tool.searchable"
				:expandable="tool.expandable"
				@remove="removeTool('slim', index)"
				@expand="expandTool('slim', index)"
				v-on="$listeners"
			/>
		</portal>

		<b-nav vertical right class="tool-bar right">
			<li
				v-for="(tool, index) in projectTools"
				:key="index"
				:data-tool="tool.key || tool.icon"
				:title="tool.displayName"
				class="tool-bar-item"
				@click="addTool(tool)"
			>
				<i :class="'tan-icon-' + tool.icon" />
				<div v-if="tool.description" class="tool-info">
					<h4
						v-if="!!tool.title"
						:class="{
							'mb-0': tool.shortcut
						}"
					>
						{{ tool.title }}
					</h4>
					<p v-if="tool.shortcut">
						({{ tool.shortcut }})
					</p>
					<!--<p v-html="tool.description.join('')" />-->
				</div>
				<ul v-if="tool.submenu" class="tool-menu list-unstyled">
					<li
						v-for="subtool in tool.submenu"
						:key="subtool.key"
						class="tool-menu-item"
						:data-tool="subtool.key"
					>
						{{ subtool.label }}
					</li>
				</ul>
			</li>
		</b-nav>
	</div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

const area = 'projectTools';

export default {
	name: 'ProjectTools',
	props: {
		scenario: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			projectTools: [
				{
					key: 'homeview',
					icon: 'home',
				},
				{
					componentName: 'ActivityLog',
					icon: 'history',
					panel: 'slim',
				},
				/* {
					componentName: 'ElementEditor',
					icon: 'create-new',
					panel: 'slim',
				}, */
				/* {
					key: 'saveScreen',
				},
				{
					componentName: 'CreateTour',
					icon: 'save-screen',
					panel: 'slim',
				},
				{
					componentName: 'FileBrowser',
					icon: 'comment',
					panel: 'slim',
				},
				{
					icon: 'collaborate',
				}, */
				/* {
					key: 'createNew',
					icon: 'create-new',
					submenu: [
						{
							key: 'building',
							label: 'Building',
						},
						{
							key: 'streetsInfrastructure',
							label: 'Streets + Infrastructure',
						},
						{
							key: 'publicSpace',
							label: 'Public Space',
						},
						{
							key: 'parcelBoundary',
							label: 'Parcel Boundary',
						},
						{
							key: 'siteBoundary',
							label: 'Site Boundary',
						},
						{
							key: 'contextualBoundary',
							label: 'Contextual Boundary',
						},
						{
							key: 'landscaping',
							label: 'Landscaping',
						},
						{
							key: 'siteActivation',
							label: 'Site Activation',
						},
						{
							key: 'gradeParking',
							label: 'Grade Parking',
						},
					],
				},
				{
					icon: 'group',
				},
				{
					icon: 'import',
				},
				{
					icon: 'measure',
				},
				{
					icon: 'optimize',
				},
				{
					icon: 'curate',
				}, */
				{
					icon: 'sunlight',
				},

				{
					icon: 'map',
				},
				{
					icon: 'translate',
				},
				{
					icon: 'compass',
				},
			],
		};
	},
	computed: {
		...mapState(['openPanels']),
		panels() {
			return this.openPanels.projectTools;
		},
		showSlim() {
			return this.panels.slim.tools.length > 0;
		},
		showWide() {
			return this.panels.wide.tools.length > 0;
		},
	},
	methods: {
		...mapMutations(['closePanel', 'expandPanel', 'openPanel']),
		addTool(tool) {
			if (tool.componentName && tool.panel)
				this.openPanel({
					area,
					panel: {
						componentName: tool.componentName,
						displayName: tool.displayName,
						searchable: tool.searchable === true,
						expandable: tool.expandable === true,
					},
					smartPanel: tool.panel,
				});
		},
		expandTool(panel, index) {
			this.expandPanel({ area, index, smartPanel: panel });
		},
		removeTool(panel, index) {
			this.closePanel({ area, index, smartPanel: panel });
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
ul {
	margin: 0;
}
.tool-bar.right .tool-info {
	right: calc(100% + 1px);
}
.tool-bar.left .tool-info {
	left: calc(100% + 1px);
}
.tool-info {
	white-space: initial;
	position: absolute;
	top: 0px;
	background: $body-bg-dark;
	padding: 0.8rem;
	width: 14rem;
	font-size: 0.7rem;
	z-index: 99999 !important;
	cursor: default;
	h4 {
		font-size: 0.75rem;
	}
	a {
		cursor: pointer;
		text-decoration: underline;
		font-weight: bold;
	}
}
.tool-bar {
	user-select: none;
	white-space: nowrap;
	margin: 0;
	&.left {
		border-right: 1px solid $body-color;
	}
	&.right {
		border-left: 1px solid $body-color;
	}
	& > hr {
		margin: 0.5rem 0;
		background: $body-color;
	}
	& > .tool-bar-item {
		position: relative;
		cursor: pointer;
		font-family: $font-family-medium;
		font-size: 1.1rem;
		padding: 0.2rem 0.2rem calc(0.2rem - 2px) 0.2rem;
		border-bottom: 1px solid $body-color;

		.tool-info,
		.tool-menu {
			display: none;
		}
		&:hover {
			background-color: $body-bg;
			.tool-info {
				display: block;
			}
		}
		&.in {
			background-color: $body-bg;
			.tool-menu {
				display: block;
			}
			.tool-info {
				display: none;
			}
		}
	}
}
.tool-menu {
	font-family: $font-family-sans-serif;
	font-size: $dropdown-font-size;
	position: absolute;
	top: 0px;
	background: $dropdown-bg;
	width: 14rem;
	padding: $dropdown-padding-y 0;
	& > .tool-menu-item {
		&:not(:last-child) {
			border-bottom: 1px solid $gray-500;
		}
		padding: $dropdown-item-padding-y $dropdown-item-padding-x;
		&:hover {
			color: $dropdown-link-hover-color;
			background: $dropdown-link-hover-bg;
		}
	}
}
li.tool-bar-item {
	font-size: 1.1rem;
	padding: 0.2rem 0.2rem calc(0.2rem - 2px) 0.2rem;
	border-bottom: 1px solid $body-color;
}

/* width */
::-webkit-scrollbar {
	width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
	background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
	background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: #555;
}
</style>
